/**
 * TenantBadge — exibe nome do tenant com chip de ambiente.
 *
 * Spec: docs/CHAMADOS_VISIBILIDADE_SPEC.md §9.3.3
 *
 * Cores ambiente:
 *  - PRD/PROD = red (alerta de producao)
 *  - QA = yellow
 *  - HML = orange
 *  - DEV = blue
 *  - default = gray
 *
 * Texto do tenant truncado com max-width 140px.
 */
import { Badge, Group, Text } from '@mantine/core'

export interface TenantBadgeProps {
  tenantName: string
  environment?: string | null
}

const ENV_COLORS: Record<string, string> = {
  PRD: 'red',
  PROD: 'red',
  QA: 'yellow',
  HML: 'orange',
  DEV: 'blue',
}

export function TenantBadge({ tenantName, environment }: TenantBadgeProps) {
  const envUpper = environment ? environment.toUpperCase() : null
  const color = envUpper ? (ENV_COLORS[envUpper] ?? 'gray') : 'gray'

  return (
    <Group gap={6} wrap="nowrap">
      <Text size="sm" truncate maw={140} title={tenantName}>
        {tenantName}
      </Text>
      {envUpper && (
        <Badge color={color} size="xs" variant="filled" aria-label={`Ambiente: ${envUpper}`}>
          {envUpper}
        </Badge>
      )}
    </Group>
  )
}
